import vendorMenuController from "../controllers/vendorMenuController";
import { userService } from "../services/userService";

const getMessage = (data) =>
  (typeof data === "string" ? data : data?.message || data?.error || data?.errors?.[0]?.message);

const getResponseError = async (response) => {
  let data = response?.response?.data ?? response?.data;
  if (data instanceof Blob) {
    const text = await data.text();
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  return getMessage(data) || response?.message || "Could not export products. Please try again.";
};

const getFilename = (disposition = "") => {
  const encoded = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  const plain = disposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
  let filename = plain?.[1] || plain?.[2] || "products.xlsx";
  if (encoded) {
    try {
      filename = decodeURIComponent(encoded[1]);
    } catch {
      // Keep the ordinary filename if the encoded header is invalid.
    }
  }
  return filename.replace(/[\\/]/g, "_").trim() || "products.xlsx";
};

export default async function exportVendorProducts() {
  const companyId = userService.getUserData()?.Compid;
  const Authorization = userService.getJwt();
  if (!companyId || !Authorization) throw new Error("Missing vendor session.");

  const response = await vendorMenuController.ExportFile({
    Authorization,
    request: { companyId },
  });
  if (response?.isAxiosError || response?.response || response?.status >= 400) {
    throw new Error(await getResponseError(response));
  }

  const headers = response?.headers || {};
  const contentType = headers["content-type"] || response?.data?.type || "";
  if (/json|text\/plain|text\/html/i.test(contentType)) {
    throw new Error(await getResponseError(response));
  }
  const blob = response?.data;
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error("The export did not return a file. Please try again.");
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = getFilename(headers["content-disposition"]);
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    // Allow the browser to start the download before releasing the file URL.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
